RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.AttributeBuilder = Marionette.Behavior.extend({

        onRender: function () {
            const me = this;
            me._processAttributes();
        },

        _processAttributes: function () {
            const me = this;

            // Adds a disabled class to elements with a true data-disable value
            const disableable = me.$('[data-disable]');
            _.each(disableable, function (elm) {
                const $elm = $(elm);

                if ($elm.data('disable')) {
                    $elm.addClass('disabled');
                    $elm.prop('disabled', true);
                }
            });

            // checks the element and sets its parent to active if
            // data-check is true
            const checkable = me.$('input[data-check]');
            _.each(checkable, function (elm) {
                const $elm = $(elm);
                if ($elm.data('check')) {
                    $elm.prop('checked', true);
                    $elm.parents('.btn, .activatable').addClass('active');
                }
            });

            // checks the element and sets its parent to active if
            // data-check is true
            const selectable = me.$('option[data-select]');
            _.each(selectable, function (elm) {
                const $elm = $(elm);
                if ($elm.data('select')) {
                    $elm.prop('selected', true);
                }
            });
        }
    });
});
